import { LOCALE } from '@sitegen/common/localization/locales';

import { ILocaleRules } from './locale.types';

export const LANGUAGE_CODE_REGEX: RegExp = /^[a-zA-Z]{2}$/;
export const LOCALE_SEPARATOR: string = '-';
export const URL_PARAM_SEPARATOR: string = '/';
/* Unique locale that is not supported by our application, has to be supported by Ubisoft */
export const EN_NORDIC: string = 'EN_NORDIC';

/**
 * If language short code is present in this mapping we can guarantee complete locale from "language" field
 * Example: fr-guinea => fr-FR
 *
 * If there is a special language-to-locale mapping present in "locales" field, this is the result
 * Example: en-nz => en-AU
 *
 * If language pattern is successful for some language, first match is the result
 * Example zh-hans-hk => zh-HK
 *
 * If no special locale or pattern is found, locale from "language" field is a guaranteed result
 */
export const LANGUAGE_TO_LOCALE_MAPPING: { [langugage: string]: ILocaleRules } = {
    /* English */
    en: {
        language: LOCALE.EN_GB,
        locales: {
            'en-au': LOCALE.EN_AU,
            'en-nz': LOCALE.EN_AU,
            'en-ca': LOCALE.EN_CA,
            'en-us': LOCALE.EN_US,
            [EN_NORDIC]: EN_NORDIC
        }
    },

    /* French */
    fr: {
        language: LOCALE.FR_FR,
        locales: {
            'fr-ca': LOCALE.FR_CA
        }
    },

    /* Spanish */
    es: {
        language: LOCALE.ES_ES,
        patterns: [
            { regex: /es-es[a-zA-Z]?/g, locale: LOCALE.ES_ES },
            { regex: /es-[a-zA-Z]+/g, locale: LOCALE.ES_MX }
        ]
    },
    ca: { language: LOCALE.ES_ES },

    /* Portuguese */
    pt: {
        language: LOCALE.PT_PT,
        locales: {
            'pt-br': LOCALE.PT_BR
        }
    },

    /* Chinese */
    zh: {
        language: LOCALE.ZH_CN,
        patterns: [
            { regex: /zh-[a-zA-Z]*[-]?tw[a-zA-Z_]*/g, locale: LOCALE.ZH_TW },
        ]
    },

    /* Nordic */
    no: { language: LOCALE.NB_NO },
    nb: { language: LOCALE.NB_NO },

    /* Other Languages */
    da: { language: LOCALE.DA_DK },
    de: { language: LOCALE.DE_DE },
    fi: { language: LOCALE.FI_FI },
    hu: { language: LOCALE.HU_HU },
    it: { language: LOCALE.IT_IT },
    nl: { language: LOCALE.NL_NL },
    pl: { language: LOCALE.PL_PL },
    ru: { language: LOCALE.RU_RU },
    sv: { language: LOCALE.SV_SE },
    tr: { language: LOCALE.TR_TR },
    uk: { language: LOCALE.UK_UA },
    ar: { language: LOCALE.AR_AE },
    ja: { language: LOCALE.JA_JP },
    ko: { language: LOCALE.KO_KR },
    th: { language: LOCALE.TH_TH },
    cs: { language: LOCALE.CS_CZ },
    nn: { language: LOCALE.NN_NO }
};

export const GET_LOCALE_TEXT = {
    LANGUAGE_CODE_LENGTH_ERROR: 'Error: Language Code Should Consist of Two Letters'
};
